// extracted by mini-css-extract-plugin
module.exports = {"bodyAlert":"AlertDelPressRelase_bodyAlert__2xpgR","btnCancel":"AlertDelPressRelase_btnCancel__2hGdD"};